// en, de, fr, pt
export default {
  fr: {
    commons: {
      saveUpdate: 'Sauvegarder les modifications',
      cancelAndGoBack: 'Annuler et revenir en arrière',
      confirmPopoverMessage: 'Êtes-vous sûr(e) ?',
      confirmButtonText: 'Oui',
      cancelButtonText: 'Annuler',
      defaultErrorMessage: 'Une erreur est survenue',
      defaultSuccessMessage: 'Opération réussie',
      updateSuccessMessage: 'Informations mises à jour',
      loading: 'Chargement...',
      choose: 'Choisir',
      missingInfo: 'Info manquante',
      operationCanceled: 'Opération annulée',
      continueButtonText: 'Continuer',
      requiredFieldMessage: 'Ce champ est requis',
    },
    roles: {
      RESPONSABLE_MAGASIN: 'Responsable magasin',
      RESPONSABLE_MAGASIN_ADJOINT: 'Responsable magasin adjoint',
      PREMIER_VENDEUR: 'Premier vendeur',
      VENDEUR: 'Vendeur',
      APPRENTI_VENTE: 'Apprenti vente',
      RESPONSABLE_PRODUCTION: 'Responsable production',
      RESPONSABLE_PRODUCTION_ADJOINT: 'Responsable production adjoint',
      BOULANGER: 'Boulanger',
      PREPARATEUR: 'Préparateur',
      APPRENTI_BOULANGER: 'Apprenti boulanger',
    },
    loginPage: {
      title: 'Connectez-vous',
      usernameLabel: 'Nom utilisateur',
      passwordLabel: 'Mot de passe',
      submitButtonText: 'Se connecter',
      successMessage: 'Vous êtes connecté(e)',
      errorAccountDisabled: 'Votre compte est provisoirement désactivé',
      errorWrongPassword: 'Mot de passe invalide',
    },
    mainNav: {
      logoutMenuItem: 'Déconnexion',
      managePasswordsItem: 'Gestion mots de passe',
      profileMenuItem: 'Mon profil',
      manageUsersMenuItem: 'Gestion personnel',
      newReceptionMenuItem: 'Nouvelle reception',
    },
    shopSignInPage: {
      title: 'Connexion magasin',
      emailLabel: 'Adresse email du magasin',
      validEmailRequiredMessage: 'Un email valide est requis',
      submitButtonText: 'Se connecter',
      successMessage: 'Un lien de connexion vous a été transmis par email',
      shopMLVerificationSuccess: 'Votre magasin est enregistré !',
    },
    chooseUserPage: {
      chooseUserButtonText: 'Choisir',
    },
    userSignInForm: {
      passwordLabel: 'Mot de passe',
      validPasswordRequiredMessage: 'Le mot de passe est requis.',
      submitButtonText: 'Me connecter',
      forgotPassword: 'Mot de passe oublié',
      cancelForgotPassword: 'Annuler',
    },
    usersListTable: {
      openButtonText: 'Ouvrir',
    },
    bonDeLivraisonStatus: {
      PENDING: 'A réceptionner',
      DELIVERED: 'Livré',
    },
  },
};
